import { render, staticRenderFns } from "./CreateCompanies.vue?vue&type=template&id=8bc6b368&"
import script from "./CreateCompanies.vue?vue&type=script&lang=js&"
export * from "./CreateCompanies.vue?vue&type=script&lang=js&"
import style0 from "./CreateCompanies.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports